import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import {
  ClipboardList,
  ShieldCheck,
  ArrowRight,
  Briefcase,
  Users,
  MapPin,
} from "lucide-react";

const perks = [
  { icon: Briefcase, text: "189+ job roles across 19 industries" },
  { icon: Users, text: "Free registration for candidates" },
  { icon: MapPin, text: "Openings across India" },
];

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#f6faf6] flex flex-col">
      <header className="px-6 sm:px-10 py-5 flex items-center justify-between">
        <Logo />
        <Link
          to="/login"
          data-testid="header-recruiter-login-link"
          className="text-sm font-medium text-brand-700 hover:text-brand-800 inline-flex items-center gap-1.5"
        >
          <ShieldCheck size={15} /> Recruiter Login
        </Link>
      </header>

      <main className="flex-1 flex items-center">
        <div className="max-w-6xl mx-auto w-full px-6 sm:px-10 py-10 grid lg:grid-cols-[1.1fr_1fr] gap-10 lg:gap-16 items-center">
          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] text-brand-700 font-semibold mb-4">
              Tulsi Jobs Placement Consultant
            </p>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-ink-900 leading-[1.08]">
              Your next job,
              <br />
              <span className="text-brand-700">one form away.</span>
            </h1>
            <p className="mt-5 text-base text-ink-600 max-w-md">
              Register in ~3 minutes. Our team matches you with verified
              openings and lines up interviews on your behalf.
            </p>
            <ul className="mt-7 space-y-2.5">
              {perks.map(({ icon: Icon, text }) => (
                <li
                  key={text}
                  className="flex items-center gap-2.5 text-sm text-ink-700"
                >
                  <span className="h-7 w-7 rounded-full bg-brand-100 text-brand-800 grid place-items-center shrink-0">
                    <Icon size={14} />
                  </span>
                  {text}
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            <Link
              to="/apply"
              data-testid="landing-apply-card"
              className="group block rounded-2xl bg-brand-700 hover:bg-brand-800 text-white p-7 shadow-lg shadow-brand-700/20 transition-colors"
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="h-11 w-11 rounded-xl bg-white/15 grid place-items-center mb-4">
                    <ClipboardList size={22} />
                  </div>
                  <h2 className="font-heading text-lg font-semibold">
                    I'm looking for a job
                  </h2>
                  <p className="mt-1 text-sm text-brand-100">
                    Apply directly — fill the candidate form and our recruiters
                    receive your details instantly.
                  </p>
                </div>
                <ArrowRight
                  size={20}
                  className="mt-1 shrink-0 transition-transform group-hover:translate-x-1"
                />
              </div>
              <div className="mt-5 inline-flex items-center gap-2 text-sm font-medium bg-white text-brand-800 rounded-full px-4 py-2">
                Apply now — it's free
              </div>
            </Link>

            <Link
              to="/login"
              data-testid="landing-recruiter-card"
              className="group block rounded-2xl bg-white border border-slate-200 hover:border-brand-300 p-7 shadow-sm transition-colors"
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="h-11 w-11 rounded-xl bg-brand-50 text-brand-800 grid place-items-center mb-4">
                    <ShieldCheck size={22} />
                  </div>
                  <h2 className="font-heading text-lg font-semibold text-ink-900">
                    I'm a recruiter / team member
                  </h2>
                  <p className="mt-1 text-sm text-ink-600">
                    Sign in to the dashboard to manage candidates, interviews
                    and payments.
                  </p>
                </div>
                <ArrowRight
                  size={20}
                  className="mt-1 shrink-0 text-brand-700 transition-transform group-hover:translate-x-1"
                />
              </div>
              <div className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-brand-700">
                Recruiter login
              </div>
            </Link>
          </div>
        </div>
      </main>

      <footer className="px-6 sm:px-10 py-5 text-center text-xs text-ink-500">
        © {new Date().getFullYear()} Tulsi Jobs Placement Consultant ·{" "}
        <a href="/terms" className="text-brand-700 hover:underline">
          Terms
        </a>{" "}
        ·{" "}
        <a href="/refund-policy" className="text-brand-700 hover:underline">
          Refund Policy
        </a>
      </footer>
    </div>
  );
}
